<template>
  <div
    class="air-monitor-material-details"
    v-loading="loading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
    element-loading-text="Loading"
  >
    <div class="detail-title">
      <title-comp :title="$t('物质信息详情')"></title-comp>
      <div style="font-size: 16px; font-weight: bold">
        <span>{{ checkTime }}</span>
      </div>
    </div>
    <el-row>
      <scrollbar type="none">
        <div class="content-box" slot="scrollbar">
          <div class="detail-content">
            <ElForm size="mini" v-if="matData.moreInfos">
              <el-form-item
                :class="v.code"
                v-for="(v, index) in matData.moreInfos"
                :key="index"
                :label="`${v.name}: `"
              >
                <p>{{ v.content }}</p>
              </el-form-item>
            </ElForm>
          </div>

          <ElTabs class="tabs" :value="tabList[0].prop" type="card">
            <ElTabPane
              v-for="item in tabList"
              :key="item.prop"
              :label="$t(item.name)"
              :name="item.prop"
            >
              <template #default>
                <div v-if="item.prop === 'defenseInfos'">
                  <template v-for="(e, i) in matData[item.prop]">
                    <el-card
                      v-if="e.content.length > 0"
                      :key="`defensen_${i}`"
                      class="v-block"
                      :header="e.title"
                    >
                      <ElTable border :data="e.content" :show-header="false">
                        <ElTableColumn prop="name" width="200"></ElTableColumn>
                        <ElTableColumn prop="content"></ElTableColumn>
                      </ElTable>
                    </el-card>
                  </template>
                </div>

                <ElTable v-else border :data="matData[item.prop]" :show-header="false">
                  <ElTableColumn prop="name" width="200"></ElTableColumn>
                  <ElTableColumn prop="content"></ElTableColumn>
                </ElTable>
              </template>
            </ElTabPane>
          </ElTabs>
        </div>
      </scrollbar>
    </el-row>
  </div>
</template>

<script>
import { getMaterialDetails } from '@/api/material';
import { materialOption } from '@/echartOption/material';

export default {
  name: 'MaterialDetails',
  props: {
    materialId: String
  },
  data() {
    return {
      checkTime: '',
      matData: {},
      loading: true,
      tabList: [
        {
          prop: 'baseInfos',
          name: '基本信息'
        },
        {
          prop: 'natureInfos',
          name: '物化性质'
        },
        {
          prop: 'securityInfos',
          name: '安全信息'
        },
        {
          prop: 'defenseInfos',
          name: '防护方案'
        }
      ]
    };
  },
  methods: {
    materialOption,
    langChangeHandler() {
      this.renderPage();
    },
    async renderPage() {
      const params = { materialId: this.materialId };

      const { data = {} } = await getMaterialDetails(params);

      const { moreInfos, baseInfos, typeName, natureInfos, securityInfos, defenseInfos } = data;

      Object.assign(this.matData, {
        moreInfos: [
          ...moreInfos.sort((a, b) => a.displaySort - b.displaySort),
          { code: 'category', name: '分类', displaySort: 99, content: typeName.replace(/;/g, ' ') }
        ],
        baseInfos,
        natureInfos,
        securityInfos,
        defenseInfos
      });

      this.loading = false;
    }
  },
  created() {
    this.renderPage();
  }
};
</script>

<style lang="scss">
.air-monitor-material-details {
  height: 100%;
  padding: 15px;
  @include border-style;

  & > .el-row {
    height: calc(100% - 70px);
    .el-col {
      height: 100%;
    }
  }

  .detail-title {
    display: flex;
    justify-content: space-between;
  }

  .content-box {
    height: 100%;

    .detail-content {
      padding-left: 15px;

      margin-bottom: 50px;

      font-size: 16px;
    }

    .el-form-item {
      margin-bottom: 5px !important;

      &__label {
        text-align: left;
      }

      &.base_006 {
        display: flex;
        flex-direction: column;

        p {
          white-space: pre-line;
        }
      }
    }
  }
  .el-card {
    margin-top: 20px;

    &__body {
      padding: 0;
    }
  }

  .el-table {
    .cell {
      white-space: pre-line;
    }
  }

  .echart-parent {
    overflow: hidden;
    height: 300px;
  }
}
</style>
